/**
 * Standard Actions configuration for Dawn.
 * (bloc d'origine du thème — inchangé)
 */

const DAWN_CART_TAGS = ['cart-drawer', 'cart-items', 'cart-drawer-items', 'cart-notification'];

const DAWN_PUBSUB_REFRESHED_SECTIONS = new Set([
  'cart-drawer:cart-drawer',
  'cart-drawer-items:CartDrawer',
  'cart-items:main-cart-items',
]);

function collectCartSections() {
  const sections = new Map();

  for (const el of document.querySelectorAll(DAWN_CART_TAGS.join(','))) {
    let entries;
    try {
      entries = el.getSectionsToRender?.();
    } catch {
      continue;
    }

    const tag = el.tagName.toLowerCase();
    for (const entry of entries ?? []) {
      if (DAWN_PUBSUB_REFRESHED_SECTIONS.has(`${tag}:${entry.id}`)) continue;

      const sectionId = entry.section ?? entry.id;
      if (!sectionId || sections.has(sectionId)) continue;

      const root = entry.section ? document.getElementById(entry.id) : document;
      if (!root) continue;

      const mount = entry.selector
        ? (root.querySelector(entry.selector) ?? (entry.section ? root : null))
        : document.getElementById(entry.id);
      if (!mount) continue;

      sections.set(sectionId, {
        mount,
        extractSelector: entry.selector || '.shopify-section',
      });
    }
  }

  return sections;
}

async function refreshDawnCartUI() {
  const sections = collectCartSections();
  const sectionsQuery = sections.size
    ? `?sections=${[...sections.keys()].join(',')}`
    : '';
  const cartUrl = (typeof routes !== 'undefined' && routes?.cart_url) || '/cart';
  const url = `${cartUrl}.js${sectionsQuery}`;
  const cartData = await fetch(url, { headers: { Accept: 'application/json' } })
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null);

  if (cartData?.sections) {
    for (const [id, { mount, extractSelector }] of sections) {
      const html = cartData.sections[id];
      if (!html) continue;
      const source = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(extractSelector);
      if (source) mount.replaceChildren(...source.childNodes);
    }
  }

  publish(PUB_SUB_EVENTS.cartUpdate, {
    source: 'external-refresh',
    cartData: cartData ?? undefined,
  });
}

function initStandardActions() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.openCart.configure({
    async handler(defaultHandler) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      return defaultHandler();
    },
  });

  actions.updateCart.configure({
    eventTarget: () => document,
    async handler(defaultHandler) {
      const result = await defaultHandler();
      try {
        await refreshDawnCartUI();
      } catch (error) {
        console.error('[Dawn] Standard Actions cart refresh failed; reloading.', error);
        window.location.reload();
      }
      return result;
    },
  });
}

if (window.Shopify?.actions) {
  initStandardActions();
} else {
  document.addEventListener('DOMContentLoaded', initStandardActions, { once: true });
}

/* ==== Spa-Suisse custom (2026-07-31) : personnalisation panier Section Store.
   A. Barre sticky. B. Jalon 150 -20px ; textes jalons 13.5/12.5px.
   C. Libellés 210->200, 310->300 (seuils app 210/310). D. Bandeau SPA10.
   E. Vibration "Ajoutez..." 1s/7s. F. Badge "N articles". G. Chips barre masqués.
   H. TOTAUX : violet 16px — libellés/montants gras, barrés 16px non gras ;
      même écart (8px) entre prix réel et barré sur Total et Palier pour que
      les "CHF" s'alignent verticalement.
   I. Barre de récompense recalculée sur items_subtotal_price HORS "Protection
      transport", remises code réintégrées ; phrase explicative si code promo
      actif ; "Félicitations..." écrit par le script ; réécriture pilotée par
      data-ss-key. Paliers réels 15000/21000/31000 cts.
   L. PANIER VIDE : bandeau, carrousel produits-entretien, barre à zéro, totaux,
      "Commander • 0.00 CHF". M. FIX bundle : ajouts via fetch natif (iframe).
   NB : seuil livraison 20000 cts, port 990 cts. ==== */
(function () {
  var ACCENT = 'rgb(130, 81, 146)';
  var MODULE_BG = 'rgb(246, 231, 252)';
  var PORT_CENTS = 990;
  var FREE_CENTS = 20000;
  var ROW_STYLE = 'display:flex;justify-content:space-between;align-items:baseline;gap:8px;margin:6px 0;color:rgb(130, 81, 146);font-size:16px;font-weight:700;';
  var TIERS = [
    { min: 15000, label: '10 CHF de réduction', prevPos: '0%', pos: '48.39%' },
    { min: 21000, label: 'Livraison gratuite', prevPos: '48.39%', pos: '67.74%' },
    { min: 31000, label: '20 CHF de réduction', prevPos: '67.74%', pos: '100.00%' }
  ];
  var CONGRATS = 'Félicitations, vous avez débloqué toutes les réductions !';
  var CODE_MSG = 'Les réductions par palier ne sont pas cumulables avec un code promo. Retirez le code pour en profiter à nouveau.';
  var CSS_ID = 'ss-cart-custom-style';
  var UPSELL_CSS_ID = 'ss-upsell-rescoped-css';
  var UPSELL_VARS = '--products-upsell-image-size:58px;--products-upsell-card-image-size:72px;--products-upsell-text-size:13px;--products-upsell-title-color:#37223E;--products-upsell-subtitle-color:#784B87;--products-upsell-button-bg:#825192;--products-upsell-button-text:#FFFFFF;--products-upsell-product-title:#37223E;--products-upsell-product-subtitle:#784B87;--products-upsell-price:#37223E;--products-upsell-compare-price:#A46FB6;--products-upsell-card-border-color:#D6B0E3;--products-upsell-card-border-width:1px;--products-upsell-card-bg:#f6e7fc';
  var CSS_TEXT = [
    '.cart-body{display:flex;flex-direction:column;}',
    '.cart-body > div{flex-shrink:0;}',
    '.cart-reward-bar,#ss-empty-reward{order:99;position:sticky;bottom:0;z-index:5;margin:0;background:' + MODULE_BG + ';}',
    '#ss-empty-upsell{display:block;padding:14px 16px 16px;}',
    '#ss-empty-announcement{order:-1;background:' + ACCENT + ';color:#fff;padding:9px 16px;}',
    '.cart-reward-text{display:block;text-align:center;color:' + ACCENT + ';font-size:16px;font-weight:600;background:none;padding:0;animation:ss-nudge 7s ease-in-out infinite;}',
    '@keyframes ss-nudge{0%,86%,100%{transform:translateX(0)}88%{transform:translateX(-2px)}90%{transform:translateX(2px)}92%{transform:translateX(-2px)}94%{transform:translateX(2px)}96%{transform:translateX(-1px)}98%{transform:translateX(0)}}',
    '@media (prefers-reduced-motion: reduce){.cart-reward-text{animation:none !important;}}',
    '.cart-reward-milestones .cart-reward-milestone:first-child{margin-left:-20px;}',
    '.cart-reward-milestone-threshold{font-size:13.5px;}',
    '.cart-reward-milestone-title{font-size:12.5px;}',
    '.cart-announcement{display:block !important;text-align:center;font-size:12px;line-height:1.35;}',
    '.cart-title-items-count{background:#fff;color:' + ACCENT + ';border-radius:999px;padding:2px 10px;font-size:12px;font-weight:700;margin-left:6px;vertical-align:middle;white-space:nowrap;}',
    '.cart-total-row.cart-subtotal-main{color:' + ACCENT + ';font-size:16px;font-weight:700;}',
    '.cart-subtotal-title{font-size:16px;font-weight:700;}',
    '.cart-subtotal-prices{display:inline-flex;flex-direction:row-reverse;gap:8px;align-items:baseline;font-size:16px;font-weight:700;}',
    '.cart-subtotal-compare{font-size:16px;color:inherit;font-weight:400;}',
    '.cart-discount-total-row{color:' + ACCENT + ';font-size:16px;font-weight:700;background:none;padding:0;border-radius:0;}',
    '#ss-tier-row s,#ss-shipping-row s{font-size:16px;font-weight:400;opacity:.75;}',
    '#ss-tier-row > span,#ss-shipping-row > span{white-space:nowrap;}',
    '.cart-footer.ss-empty .cart-discount-code{margin-top:10px;}',
    '.cart-footer.ss-empty .cart-checkout-button{margin-top:4px;}',
    /* ---- MOBILE (<600px) : tout défile dans le drawer ; seuls le header,
       la barre de récompense (haut) et le bouton Commander (bas) sont sticky ---- */
    '@media (max-width: 599px){',
    '.cart-drawer{overflow-y:auto;overflow-x:hidden;}',
    '.cart-body{display:contents;}',
    '.cart-footer{display:contents;}',
    '.cart-top-bar{position:sticky;top:0;z-index:12;order:-3;height:48px;min-height:48px;padding-top:0;padding-bottom:0;align-content:center;}',
    '.cart-top-bar h2,.cart-top-bar h3,.cart-title{font-size:17px;}',
    '.cart-title-items-count{font-size:11px;padding:2px 8px;}',
    '.cart-error{order:-2;}',
    '.cart-reward-bar,#ss-empty-reward{order:-1;position:sticky;top:48px;bottom:auto;z-index:11;box-shadow:0 2px 6px rgba(55,34,62,.10);}',
    '.cart-reward-text{font-size:13px;}',
    '.cart-reward{--reward-milestone-size:30px !important;--reward-tier-title-size:10px !important;--reward-padding-top:9px !important;--reward-padding-bottom:9px !important;--reward-progress-extra-bottom:14px !important;}',
    '.cart-reward-milestone-threshold{font-size:11px;}',
    '.cart-reward-milestone-title{font-size:10px;}',
    '.cart-announcement{font-size:11px;padding:7px 12px;}',
    '.cart-footer > div,.cart-footer > ul{background:rgb(242, 235, 245);margin:0;padding:6px 16px;}',
    '.cart-footer > div:empty{display:none;}',
    '.cart-footer > .cart-footer-toast{padding:0;}',
    '.cart-footer > .cart-order-upsells{padding-top:12px;border-top:1px solid rgba(18,18,18,.08);}',
    '.cart-order-upsell{padding:8px 12px;font-size:13px;}',
    '.cart-subtotal-title,.cart-subtotal-prices,.cart-subtotal-compare,.cart-discount-total-row{font-size:14px !important;}',
    '#ss-tier-row,#ss-shipping-row{font-size:14px !important;}',
    '#ss-tier-row s,#ss-shipping-row s{font-size:14px !important;}',
    '.cart-checkout-button{position:sticky;bottom:0;z-index:10;padding:8px 16px calc(10px + env(safe-area-inset-bottom));box-shadow:0 -4px 10px rgba(55,34,62,.08);}',
    '.cart-trust-badges{flex-wrap:nowrap;justify-content:center;gap:14px;margin:0;padding:8px 12px;}',
    '.cart-trust-badge{font-size:11px;gap:4px;white-space:nowrap;}',
    '.cart-trust-badge svg,.cart-trust-badge img{width:14px;height:14px;}',
    '.cart-payment-icons{flex-wrap:nowrap;gap:4px;justify-content:center;padding-bottom:calc(10px + env(safe-area-inset-bottom));}',
    '.cart-payment-icons li,.cart-payment-icons img{width:31px;height:20px;}',
    '}'
  ].join('\n');

  var lastBtnTarget = null;
  var lastData = null;
  var productsList = null;
  var productsLoading = false;

  var DOT_TAG = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M10.7 3.3 16.7 9.3a1 1 0 0 1 0 1.4l-6 6a1 1 0 0 1-1.4 0L3.3 10.7A1 1 0 0 1 3 10V5a2 2 0 0 1 2-2h5a1 1 0 0 1 .7.3ZM7 7.75A1.25 1.25 0 1 0 7 5.25a1.25 1.25 0 0 0 0 2.5Z"></path></svg>';
  var DOT_TRUCK = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M3 5.5A1.5 1.5 0 0 1 4.5 4h7A1.5 1.5 0 0 1 13 5.5V7h1.3c.4 0 .78.16 1.06.44l1.7 1.7c.28.28.44.66.44 1.06v3.3H16a2 2 0 1 1-4 0H8a2 2 0 1 1-4 0H3v-8Zm10 3v3.5h3v-1.55L14.55 8.5H13Z"></path></svg>';
  var REWARD_STYLE = '--reward-text-color:#37223E;--reward-bg-color:#F6E7FC;--reward-tier-unlocked-icon-color:#F6E7FC;--reward-tier-locked-icon-color:#825192;--reward-bar-bg-color:#EACFF3;--reward-bar-fill-color:#825192;--reward-tier-color:#784B87;--reward-tier-unlocked-color:#37223E;--reward-tier-dot-bg-color:#ffffff;--reward-tier-dot-border-color:#D6B0E3;--reward-milestone-size:38px;--reward-tier-title-size:10.5px;--reward-progress-extra-bottom:18px;--reward-track-height:7px;--reward-padding-top:16px;--reward-padding-bottom:16px';
  var BANNER_HTML = '🎉 Nouveau client : <strong>-10 %</strong> sur votre 1ère commande avec le code <strong>SPA10</strong> <span style="font-size:10.5px;opacity:.85;">(non cumulable avec les autres remises)</span>';

  function fmt(cents) { return (cents / 100).toFixed(2) + ' CHF'; }
  function norm(s) { return String(s || '').replace(/’/g, "'"); }

  function milestoneHtml(pos, svg, thr, title) {
    return '<span class="cart-reward-milestone" style="--reward-milestone-position:' + pos + '"><span class="cart-reward-milestone-dot">' + svg + '</span><span class="cart-reward-milestone-threshold">' + thr + '</span><span class="cart-reward-milestone-title">' + title + '</span></span>';
  }

  function emptyRewardHtml() {
    return '<div class="cart-reward" style="' + REWARD_STYLE + '">' +
      '<p class="cart-reward-text">Ajoutez <strong>150.00 CHF</strong> pour débloquer <strong>10 CHF de réduction</strong>.</p>' +
      '<div class="cart-reward-progress"><div class="cart-reward-track"><span class="cart-reward-fill" style="--reward-fill-start:0%;--reward-fill-next:48.39%;--reward-fill-t:0"></span></div>' +
      '<div class="cart-reward-milestones">' +
      milestoneHtml('48.39%', DOT_TAG, '150 CHF', '10 CHF de réduction') +
      milestoneHtml('67.74%', DOT_TRUCK, '200 CHF', 'Livraison gratuite') +
      milestoneHtml('100.00%', DOT_TAG, '300 CHF', '20 CHF de réduction') +
      '</div></div></div>';
  }

  function cardHtml(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    var img = p.images && p.images[0] ? p.images[0].src : '';
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=240';
    var price = v ? parseFloat(v.price).toFixed(2) : '';
    var url = '/products/' + p.handle;
    var title = String(p.title).replace(/</g, '&lt;');
    return '<article class="cart-products-upsell-card">' +
      '<a class="cart-products-upsell-image" href="' + url + '">' + (img ? '<img src="' + img + '" alt="' + title + '" loading="lazy">' : '') + '</a>' +
      '<span class="cart-products-upsell-content">' +
      '<a class="cart-products-upsell-product-title cart-products-upsell-product-title--link" href="' + url + '">' + title + '</a>' +
      '<span class="cart-products-upsell-product-subtitle"></span>' +
      '<span class="cart-products-upsell-price-row"><span class="cart-products-upsell-price">' + price + ' CHF</span></span>' +
      '</span>' +
      '<button type="button" class="cart-products-upsell-button" data-ss-add="' + (v ? v.id : '') + '">+ Ajouter</button>' +
      '</article>';
  }

  function nativeAddToCart(variantId, qty) {
    qty = qty || 1;
    var f = document.createElement('iframe');
    f.style.display = 'none';
    document.body.appendChild(f);
    var nf;
    try { nf = f.contentWindow.fetch.bind(f.contentWindow); } catch (e) { nf = null; }
    var doAdd = nf
      ? nf('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: qty }) })
      : Promise.reject();
    return doAdd
      .then(function () {
        f.remove();
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: {} }) });
      })
      .catch(function () {
        f.remove();
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: qty }) });
      });
  }

  function ensureUpsellCss(sr) {
    if (sr.getElementById(UPSELL_CSS_ID)) return;
    var out = [];
    function walk(rules) {
      for (var i = 0; i < rules.length; i++) {
        var r = rules[i];
        if (r.cssRules && r.conditionText !== undefined) {
          var inner = [];
          var keep = out;
          out = inner;
          walk(r.cssRules);
          out = keep;
          if (inner.length) out.push('@media ' + r.conditionText + '{' + inner.join('\n') + '}');
        } else if (r.selectorText && /\.cart-products-upsell(?![\w-])/.test(r.selectorText)) {
          out.push(r.cssText.replace(/\.cart-products-upsell(?![\w-])/g, '#ss-empty-upsell'));
        }
      }
    }
    try {
      for (var s = 0; s < sr.styleSheets.length; s++) {
        try { walk(sr.styleSheets[s].cssRules); } catch (e) {}
      }
    } catch (e) {}
    if (!out.length) return;
    var st = document.createElement('style');
    st.id = UPSELL_CSS_ID;
    st.textContent = out.join('\n');
    sr.appendChild(st);
  }

  function loadProducts(onReady) {
    if (productsList) { onReady(); return; }
    if (productsLoading) return;
    productsLoading = true;
    fetch('/collections/produits-entretien/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        productsList = (j.products || []).filter(function (p) {
          return norm(p.product_type) === "Produits d'Entretien" && (p.variants || []).some(function (v) { return v.available; });
        }).slice(0, 10);
        productsLoading = false;
        onReady();
      })
      .catch(function () { productsLoading = false; });
  }

  function buildEmptyState(sr) {
    var footer = sr.querySelector('.cart-footer');
    if (footer) {
      var mobile = window.matchMedia && window.matchMedia('(max-width: 599px)').matches;
      footer.style.setProperty('display', mobile ? 'contents' : 'block', 'important');
      footer.classList.add('ss-empty');
    }
    ensureUpsellCss(sr);
    var wrap = sr.getElementById('ss-empty-extras');
    var intact = wrap && wrap.querySelector('#ss-empty-reward .cart-reward-text');
    if (!intact) {
      if (wrap) wrap.remove();
      var anchor = sr.querySelector('.cart-empty');
      if (!anchor) return;
      wrap = document.createElement('div');
      wrap.id = 'ss-empty-extras';
      wrap.style.display = 'contents';
      wrap.innerHTML =
        '<div id="ss-empty-announcement" class="cart-announcement" data-ss-custom="1">' + BANNER_HTML + '</div>' +
        '<div id="ss-empty-upsell" data-layout="horizontal_card" style="' + UPSELL_VARS + '">' +
          '<div class="cart-products-upsell-header"><span class="cart-products-upsell-heading"><h3 class="cart-products-upsell-title">N\'oubliez pas ces indispensables</h3></span>' +
          '<span class="cart-products-upsell-nav"><button type="button" class="cart-products-upsell-nav-button" data-ss-nav="-1" aria-label="Précédent"><svg width="14" height="14" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>' +
          '<button type="button" class="cart-products-upsell-nav-button" data-ss-nav="1" aria-label="Suivant"><svg width="14" height="14" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></span></div>' +
          '<div class="cart-products-upsell-list" data-ss-list=""></div>' +
        '</div>' +
        '<div id="ss-empty-reward">' + emptyRewardHtml() + '</div>';
      anchor.insertAdjacentElement('afterend', wrap);
      wrap.addEventListener('click', function (ev) {
        var nav = ev.target.closest('[data-ss-nav]');
        if (nav) {
          var list = wrap.querySelector('[data-ss-list]');
          if (list) list.scrollBy({ left: 190 * parseInt(nav.getAttribute('data-ss-nav'), 10), behavior: 'smooth' });
          return;
        }
        var btn = ev.target.closest('[data-ss-add]');
        if (btn && btn.getAttribute('data-ss-add')) {
          btn.disabled = true;
          nativeAddToCart(parseInt(btn.getAttribute('data-ss-add'), 10))
            .catch(function () { btn.disabled = false; });
        }
      });
    }
    var list = wrap.querySelector('[data-ss-list]');
    if (list && !list.childElementCount) {
      if (productsList) {
        list.innerHTML = productsList.map(cardHtml).join('');
      } else {
        loadProducts(function () {
          var w = sr.getElementById('ss-empty-extras');
          var l = w && w.querySelector('[data-ss-list]');
          if (l && !l.childElementCount && productsList) l.innerHTML = productsList.map(cardHtml).join('');
        });
      }
    }
  }

  function removeEmptyState(sr) {
    var w = sr.getElementById('ss-empty-extras');
    if (w) w.remove();
    var footer = sr.querySelector('.cart-footer');
    if (footer) {
      footer.classList.remove('ss-empty');
      if (footer.style.getPropertyValue('display')) footer.style.removeProperty('display');
    }
  }

  function applyBanner(sr) {
    sr.querySelectorAll('.cart-announcement').forEach(function (ann) {
      if (!ann.dataset.ssCustom) {
        ann.dataset.ssCustom = '1';
        ann.innerHTML = BANNER_HTML;
      }
    });
  }

  function applyLabels(sr) {
    sr.querySelectorAll('.cart-reward-milestone-threshold').forEach(function (el) {
      var t = el.textContent;
      var n = t
        .replace(/\b210(?:[.,]00?)?\b/, '200')
        .replace(/\b310(?:[.,]00?)?\b/, '300');
      if (n !== t) el.textContent = n;
    });
    sr.querySelectorAll('.cart-reward-text').forEach(function (rt) {
      var wantAnim = /^Ajoutez/i.test(rt.textContent.trim()) ? '' : 'none';
      if (rt.style.animation !== wantAnim) rt.style.animation = wantAnim;
    });
  }

  function isProtection(i) {
    return /^protection/i.test(String(i.product_title || i.title));
  }

  function codeIsActive(cart) {
    if ((cart.cart_level_discount_applications || []).some(function (d) { return d.type === 'discount_code'; })) return true;
    return (cart.items || []).some(function (i) {
      return (i.line_level_discount_allocations || []).some(function (a) {
        return a.discount_application && a.discount_application.type === 'discount_code';
      });
    });
  }

  /* Rabais "de base" (prix barrés compare_at) : /cart.js ne les connaît pas
     (original_total_price part du prix de vente). On va donc chercher les
     compare_at_price par variante via /products/{handle}.js (cache mémoire),
     puis on les réintègre dans les prix barrés des totaux et du bouton. */
  var compareAt = {};
  var comparePending = {};

  function ensureCompareAt(cart, onReady) {
    var missing = {};
    (cart.items || []).forEach(function (i) {
      if (compareAt[i.variant_id] === undefined && !comparePending[i.handle]) missing[i.handle] = true;
    });
    function markZero(h) {
      (cart.items || []).forEach(function (i) {
        if (i.handle === h && compareAt[i.variant_id] === undefined) compareAt[i.variant_id] = 0;
      });
    }
    Object.keys(missing).forEach(function (h) {
      comparePending[h] = true;
      fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          delete comparePending[h];
          if (p && p.variants) p.variants.forEach(function (v) { compareAt[v.id] = v.compare_at_price || 0; });
          else markZero(h);
          onReady();
        })
        .catch(function () { delete comparePending[h]; markZero(h); });
    });
  }

  function baseDiscount(cart) {
    var d = 0;
    (cart.items || []).forEach(function (i) {
      var c = compareAt[i.variant_id];
      if (c && c > i.original_price) d += (c - i.original_price) * i.quantity;
    });
    return d;
  }

  function rewardBase(cart) {
    var S = cart.items_subtotal_price;
    (cart.items || []).forEach(function (i) {
      if (isProtection(i)) { S -= i.final_line_price; return; }
      (i.line_level_discount_allocations || []).forEach(function (a) {
        if (a.discount_application && a.discount_application.type === 'discount_code') S += a.amount;
      });
    });
    return S;
  }

  function applyRewardMath(sr, cart) {
    if (!cart.item_count) return;
    var S = rewardBase(cart);
    var code = codeIsActive(cart);
    var next = null;
    for (var i = 0; i < TIERS.length; i++) { if (S < TIERS[i].min) { next = TIERS[i]; break; } }
    var rt = sr.querySelector('.cart-reward-bar .cart-reward-text');
    if (rt) {
      var key = code ? 'code' : (next ? 'a' + (next.min - S) : 'done');
      if (rt.dataset.ssKey !== key) {
        rt.dataset.ssKey = key;
        rt.innerHTML = code
          ? CODE_MSG
          : (next
            ? 'Ajoutez <strong>' + fmt(next.min - S) + '</strong> pour débloquer <strong>' + next.label + '</strong>.'
            : CONGRATS);
      }
    }
    var fill = sr.querySelector('.cart-reward-bar .cart-reward-fill');
    if (fill) {
      var start, nextPos, t;
      if (next) {
        var prevMin = 0;
        for (var j = 0; j < TIERS.length; j++) { if (TIERS[j] === next) break; prevMin = TIERS[j].min; }
        start = next.prevPos;
        nextPos = next.pos;
        t = Math.max(0, Math.min(1, (S - prevMin) / (next.min - prevMin)));
      } else {
        start = '67.74%';
        nextPos = '100.00%';
        t = 1;
      }
      if (fill.style.getPropertyValue('--reward-fill-start') !== start) fill.style.setProperty('--reward-fill-start', start);
      if (fill.style.getPropertyValue('--reward-fill-next') !== nextPos) fill.style.setProperty('--reward-fill-next', nextPos);
      var tv = String(Math.round(t * 100) / 100);
      if (fill.style.getPropertyValue('--reward-fill-t') !== tv) fill.style.setProperty('--reward-fill-t', tv);
    }
    var miles = sr.querySelectorAll('.cart-reward-bar .cart-reward-milestone');
    for (var k = 0; k < miles.length && k < TIERS.length; k++) {
      var unlocked = S >= TIERS[k].min;
      if (miles[k].classList.contains('is-unlocked') !== unlocked) miles[k].classList.toggle('is-unlocked', unlocked);
    }
  }

  function applyBadge(sr, count) {
    var el = sr.querySelector('.cart-title-items-count');
    if (!el) return;
    var n = (count != null) ? count : parseInt(el.textContent, 10);
    if (isNaN(n)) return;
    var want = n + (n > 1 ? ' articles' : ' article');
    if (el.textContent !== want) el.textContent = want;
  }

  function applyData(sr, cart) {
    ensureCompareAt(cart, function () { applyData(sr, cart); });
    var free = cart.total_price >= FREE_CENTS;
    var hasItems = cart.item_count > 0;
    var S = cart.items_subtotal_price;
    var total = cart.total_price;
    // prix "avant tout" = original_total_price (avant remises bundle/palier/code)
    // + rabais de base compare_at (inconnus de /cart.js)
    var original = cart.original_total_price + baseDiscount(cart);
    var dispTotal = hasItems && !free ? total + PORT_CENTS : total;
    var dispCompare = hasItems ? original + PORT_CENTS : original;
    var merch = original - total;

    if (!hasItems) buildEmptyState(sr); else removeEmptyState(sr);
    applyRewardMath(sr, cart);

    var apps = cart.cart_level_discount_applications || [];
    var tier = null;
    var barAmounts = {};
    apps.forEach(function (d) {
      var m = String(d.title).trim().match(/^-(10|20)$/);
      if (d.type !== 'discount_code' && m) {
        tier = { amount: parseInt(m[1], 10), label: m[1] === '10' ? '150' : '300' };
        barAmounts[d.total_allocated_amount] = true;
      }
    });

    var titleEl = sr.querySelector('.cart-subtotal-title');
    if (titleEl && titleEl.textContent !== 'Total panier (TVA incl.)') titleEl.textContent = 'Total panier (TVA incl.)';
    var prices = sr.querySelector('.cart-subtotal-prices');
    if (prices) {
      var compare = prices.querySelector('.cart-subtotal-compare');
      var real = prices.querySelector('span:not(.cart-subtotal-compare)');
      if (real && real.textContent !== fmt(S)) real.textContent = fmt(S);
      if (compare) {
        if (hasItems && original > S) {
          compare.style.display = '';
          if (compare.textContent !== fmt(original)) compare.textContent = fmt(original);
        } else {
          compare.style.display = 'none';
        }
      }
    }

    var subtotal = sr.querySelector('.cart-subtotal');
    if (subtotal) {
      var tierRow = sr.getElementById('ss-tier-row');
      if (tier && hasItems) {
        if (!tierRow) {
          tierRow = document.createElement('div');
          tierRow.id = 'ss-tier-row';
          tierRow.className = 'cart-total-row';
          subtotal.appendChild(tierRow);
        }
        tierRow.style.cssText = ROW_STYLE;
        // même écart de 8px entre prix réel et barré que sur la ligne Total,
        // pour que les "CHF" des prix réels s'alignent verticalement
        var wantT = '<span>Palier ' + tier.label + ' : -' + tier.amount + ' CHF</span>' +
          '<span style="display:inline-flex;gap:8px;align-items:baseline;">' + fmt(total) + (original > total ? '<s>' + fmt(original) + '</s>' : '') + '</span>';
        if (tierRow.innerHTML !== wantT) tierRow.innerHTML = wantT;
      } else if (tierRow) {
        tierRow.remove();
      }
      var row = sr.getElementById('ss-shipping-row');
      if (!row) {
        row = document.createElement('div');
        row.id = 'ss-shipping-row';
        row.className = 'cart-total-row';
        subtotal.appendChild(row);
      }
      row.style.cssText = ROW_STYLE;
      var showFree = free && hasItems;
      var wantL = showFree
        ? '<span>Livraison</span><span>gratuite (-9.90 CHF)</span>'
        : '<span>Livraison (gratuite dès 200 CHF)</span><span>+9.90 CHF</span>';
      if (row.innerHTML !== wantL) row.innerHTML = wantL;
      var tr = sr.getElementById('ss-tier-row');
      if (tr && tr.nextElementSibling !== row) subtotal.insertBefore(tr, row);
    }

    var reduc = sr.querySelector('.cart-discount-total-row');
    if (reduc) {
      var spans = reduc.querySelectorAll('span');
      var amountSpan = spans[spans.length - 1];
      var totalReduc = merch + (free && hasItems ? PORT_CENTS : 0);
      var wantR = '-' + fmt(totalReduc);
      if (amountSpan && amountSpan.textContent !== wantR) amountSpan.textContent = wantR;
    }

    var link = sr.querySelector('.cart-checkout-link');
    var span = link ? link.querySelector('.cart-checkout-text') : null;
    if (span) {
      var prefix = span.textContent.split('•')[0].trim();
      var wantBtn = prefix + ' • ' + fmt(dispTotal);
      if (span.textContent !== wantBtn) span.textContent = wantBtn;
      var s = sr.getElementById('ss-checkout-strike');
      if (hasItems && dispCompare > dispTotal) {
        if (!s) {
          s = document.createElement('span');
          s.id = 'ss-checkout-strike';
          span.insertAdjacentElement('afterend', s);
        }
        var gap = parseFloat(getComputedStyle(link).gap) || 0;
        s.style.whiteSpace = 'pre';
        s.style.marginLeft = (-gap) + 'px';
        var wantS = ' • <s>' + fmt(dispCompare) + '</s>';
        if (s.innerHTML !== wantS) s.innerHTML = wantS;
      } else if (s) {
        s.remove();
      }
    }

    sr.querySelectorAll('.cart-applied-discount').forEach(function (chip) {
      var txt = (chip.textContent || '').replace(/\s+/g, '');
      var mm = txt.match(/-?(\d+(?:\.\d+)?)CHF/);
      var cents = mm ? Math.round(parseFloat(mm[1]) * 100) : null;
      chip.style.display = (cents != null && barAmounts[cents]) ? 'none' : '';
    });

    applyBadge(sr, cart.item_count);
  }

  function updateAll(host) {
    var sr = host.shadowRoot;
    if (!sr.getElementById(CSS_ID)) {
      var st = document.createElement('style');
      st.id = CSS_ID;
      st.textContent = CSS_TEXT;
      sr.appendChild(st);
    }
    applyBanner(sr);
    applyLabels(sr);
    var span = sr.querySelector('.cart-checkout-link .cart-checkout-text');
    if (!span) { applyBadge(sr, null); return; }
    if (lastData && span.textContent === lastBtnTarget) {
      applyData(sr, lastData);
      return;
    }
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        lastData = cart;
        applyData(sr, cart);
        var spanNow = sr.querySelector('.cart-checkout-link .cart-checkout-text');
        lastBtnTarget = spanNow ? spanNow.textContent : null;
      })
      .catch(function () {});
  }

  function setup() {
    var host = document.querySelector('section-store--cart-block');
    if (!host || !host.shadowRoot) return false;
    updateAll(host);
    new MutationObserver(function () { updateAll(host); }).observe(host.shadowRoot, { childList: true, subtree: true, characterData: true });
    return true;
  }

  /* Pages produit à bundle : l'app patche fetch/XHR et ajoute le produit de la
     page (× quantité bundle) à TOUT appel /cart/add.js. On intercepte donc les
     formulaires quick-add (collection en vedette, modale quick-add) et on passe
     par nativeAddToCart (fetch natif via iframe) pour n'ajouter QUE le produit
     cliqué. Si window.fetch est natif (page sans bundle), on ne touche à rien. */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!/^quick-add/.test(String(form.getAttribute('id') || '')) && !form.closest('quick-add-modal')) return;
    if (/\[native code\]/.test(String(window.fetch))) return;
    var fd = new FormData(form);
    var id = parseInt(fd.get('id'), 10);
    if (!id) return;
    var qty = parseInt(fd.get('quantity'), 10) || 1;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('disabled', 'disabled');
    nativeAddToCart(id, qty)
      .then(function () {
        if (btn) btn.removeAttribute('disabled');
        var qm = form.closest('quick-add-modal');
        if (qm && typeof qm.hide === 'function') qm.hide();
        setTimeout(function () {
          var host = document.querySelector('section-store--cart-block');
          var visible = false;
          if (host && host.shadowRoot) {
            var el = host.shadowRoot.querySelector('.cart-body');
            if (el) {
              var r = el.getBoundingClientRect();
              visible = r.width > 0 && r.height > 0 && r.right > 0 && r.left < window.innerWidth && getComputedStyle(el).visibility !== 'hidden';
            }
          }
          if (!visible) {
            var icon = document.getElementById('cart-icon-bubble') || document.querySelector('a[href*="/cart"]');
            if (icon) icon.click();
          }
        }, 500);
      })
      .catch(function () { if (btn) btn.removeAttribute('disabled'); });
  }, true);

  if (!setup()) {
    var obs = new MutationObserver(function () { if (setup()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
